import {
    colorBaseGreyWarm500,
    colorBaseOrange500,
    IconClose,
    Logo,
    ProductButton,
    ProductHeading,
    ProductParagraph,
    Spacing,
} from '@issuu/silkscreen';
import React, { useCallback, /*useContext,*/ useEffect, useState } from 'react';
import styled from 'styled-components';

import { HEADER_Z_INDEX } from '../../constants';
// import DocumentContext from '../DocumentPage/DocumentContext';

export interface BeforeInstallPromptEvent extends Event {
    readonly platforms: string[];
    readonly userChoice: Promise<{
        outcome: 'accepted' | 'dismissed';
        platform: string;
    }>;
    prompt(): Promise<void>;
}

declare global {
    interface WindowEventMap {
        beforeinstallprompt: BeforeInstallPromptEvent;
    }
}

const Root = styled.div`
    position: fixed;
    top: 0;
    width: 100%;
    z-index: ${HEADER_Z_INDEX};
    background-color: white;
    border-block-end: 1px solid ${colorBaseGreyWarm500};
    display: flex;
    align-items: center;
`;

const LogoBox = styled.div`
    flex-shrink: 0;
    width: 3.5rem;
    height: 3.5rem;
    padding: 0.6rem 0.4rem 0.4rem 0.6rem;
    border-radius: 0.5rem;
    background-color: ${colorBaseOrange500};
`;

export type DialogProps = {
    install: () => void;
    close: () => void;
};

export const InstallDialog: React.FC<DialogProps> = ({ close, install }: DialogProps) => {
    // const {
    //     trackers: { monitor: monitorTracker, website: websiteTracker },
    // } = useContext(DocumentContext);
    // useEffect(() => {
    //     monitorTracker({
    //         type: 'android-install-prompt.shown',
    //     });
    //     websiteTracker({
    //         type: 'android_install_prompt_shown',
    //     });
    // }, []);
    return (
        <Root aria-label="Install app" role="dialog">
            <Spacing bottom={1} left={1} top={1}>
                <ProductButton
                    icon={<IconClose />}
                    iconPlacement="alone"
                    onClick={close}
                    variant="ghost"
                >
                    Dismiss
                </ProductButton>
            </Spacing>
            <Spacing bottom={1} top={1}>
                <LogoBox>
                    <Logo color="white" mode="icon-only" />
                </LogoBox>
            </Spacing>
            <Spacing bottom={1} left={1} right={2} top={1}>
                <ProductHeading level={2} step="negative-2">
                    Issuu
                </ProductHeading>
                <ProductParagraph>Install Issuu App and discover more</ProductParagraph>
            </Spacing>
            <Spacing bottom={1} right={1} top={1}>
                <ProductButton autoFocus onClick={install} size="large" variant="secondary">
                    Install
                </ProductButton>
            </Spacing>
        </Root>
    );
};

export const AndroidInstallPrompt: React.FC = () => {
    const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent>();
    // const {
    //     trackers: { website: websiteTracker },
    // } = useContext(DocumentContext);
    useEffect(() => {
        const promptCatcher = (e: BeforeInstallPromptEvent) => {
            // Prevent Chrome >=76 from automatically showing the prompt
            e.preventDefault();
            if (!deferredPrompt) {
                // Stash the event so it can be triggered later.
                setDeferredPrompt(e);
            }
        };
        window.addEventListener('beforeinstallprompt', promptCatcher);
        return () => window.removeEventListener('beforeinstallprompt', promptCatcher);
    }, []);
    const installHandler = useCallback(() => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        // websiteTracker({
        //     type: 'android_install_prompt_start',
        // });
    }, [deferredPrompt]);
    const close = () => {
        setDeferredPrompt(undefined);
    };
    return deferredPrompt ? <InstallDialog close={close} install={installHandler} /> : null;
};
